module.exports = __webpack_public_path__ + "static/media/mark2.a7e411f6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lists/mark2.svg
// module id = 1592
// module chunks = 0